

















































































































































































































































































































































import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import { GetReportSummaryList } from "@/api/pdQualityControlManage/pdSummary";
import PdSummaryColumnar from "./columnar.vue";
import PdSummaryCake from "./cake.vue";
@Component({
    components: {
    PdSummaryColumnar,
    PdSummaryCake
  }
})
export default class pdSummary extends AbpBase {
  time: any = new Date();
  loading: boolean = false;
  showCake: boolean = false;
  showColumnar: boolean = false;
  pdHandSummary: any = {};
  pdInfectionSum: any = {};
  pdInfectionAdd: any = {};
  pdOutInfectionSum: any = {};
  pdOutInfectionAdd: any = {};
  chartData: any = {};
  async getData() {
    if (this.time == null || this.time == "") {
      return;
    }
    this.loading = true;
    let res = await GetReportSummaryList(this.fmtDate(this.time, "yyyy-MM-dd"));
    this.pdHandSummary = res.objects.pdHandSummary;
    this.pdInfectionSum = res.objects.pdInfectionSum;
    this.pdInfectionAdd = res.objects.pdInfectionAdd;
    this.pdOutInfectionSum = res.objects.pdOutInfectionSum;
    this.pdOutInfectionAdd = res.objects.pdOutInfectionAdd;
    this.loading = false;
  }
  //显示历史数据趋势图
  showChart(fieldCode: string, fieldName: string) {
    this.chartData = {
        time : this.fmtDate(this.time, "yyyy-MM-dd"),
        chartType : fieldCode
      };
    if(fieldName=="cake"){
      this.showCake=true;
    }else{
      this.showColumnar=true;
    }
  }
  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdQualityControlManage/pdSummary/index.vue